import { useLocation, Link } from 'react-router-dom';
import { GlassCard } from '@/components/ui/GlassCard';
import { Sparkles } from 'lucide-react';

const TITLES: Record<string, string> = {
  '/demo/earnings': 'Earnings',
  '/demo/settings': 'Settings',
  '/demo/support': 'Support',
};

export function DemoComingSoon() {
  const { pathname } = useLocation();
  const title = TITLES[pathname] || 'This page';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-snow uppercase tracking-widest">{title}</h1>
        <p className="text-gray-400 mt-1">Available in the live app</p>
      </div>

      <GlassCard className="text-center py-16 max-w-2xl mx-auto">
        <div className="w-16 h-16 rounded-full bg-primary-500/10 flex items-center justify-center mx-auto mb-6">
          <Sparkles className="w-8 h-8 text-primary-400" />
        </div>
        <h2 className="text-xl font-semibold text-white mb-3">Not in this demo</h2>
        <p className="text-gray-400 mb-6 max-w-md mx-auto">
          {title} is fully functional inside Romulus. This walkthrough focuses on the lead-generation
          flow — try creating a campaign, scraping leads, and generating a site.
        </p>
        <Link
          to="/demo/campaigns"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-primary-500 to-primary-400 text-white px-5 py-2.5 rounded-lg text-sm font-medium"
        >
          Try the campaign flow
        </Link>
      </GlassCard>
    </div>
  );
}
